import React from "react";

interface Props {
  value: number; // 0-100
  color?: string; // hex ou gradient css
  height?: number;
  className?: string;
}

const ProgressBar: React.FC<Props> = ({ value, color = "#3b63f6", height = 8, className }) => {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div
      className={`w-full rounded-full bg-white/10 overflow-hidden ${className || ""}`}
      style={{ height }}
      role="progressbar"
      aria-valuenow={v}
      aria-valuemin={0}
      aria-valuemax={100}>
      <div className="h-full rounded-full transition-all duration-500" style={{ width: `${v}%`, background: color }} />
    </div>
  );
};

export default ProgressBar;
